<div class="scroll-xy" *ngIf="product$ | async; let product" class="flex h-full w-full flex-col">
  <div class="flex flex-none basis-[50px] flex-row items-center justify-end">
    <ion-button class="close" fill="clear" shape="round" (click)="closeDialog()">
      <ion-icon name="close-outline"></ion-icon>
    </ion-button>
  </div>
  <div class="dialog-content flex flex-1 flex-col pb-20 pl-20 pr-20 pt-0">
    <div class="flex flex-1 flex-wrap lg:gap-10">
      <div class="flex w-full items-center justify-center sm:w-1/2">
        <img [src]="product.pictureUrl" class="img-product" />
      </div>
      <div class="flex flex-1 flex-col items-center">
        <h2>¡Ey, espera!</h2>
        <div class="description">
          <p>¿Has visto nuestra camiseta solidaria?</p>
          <p>
            Con la compra de esta camiseta, donaremos alimentos para que Mensajeros de la Paz puedan distribuirlo en
            forma de desayunos para los que más lo necesitan.
          </p>
        </div>
      </div>
    </div>
    <div classL="flex flex-wrap justify-end items-center">
      <ion-button class="flex-1" fill="outline" expand="block" (click)="closeDialog()">
        No, quizás en otro momento
      </ion-button>
      <ion-button class="flex-1" (click)="onView()" expand="block"> A ver esa camiseta &nbsp; 👀 </ion-button>
    </div>
  </div>
</div>
